// extracted by mini-css-extract-plugin
export default {"outputValid":"OutputInfo_outputValid__ITRoJ","outputInvalid":"OutputInfo_outputInvalid__3uk+n"};